import { render } from "./Pediatrics.vue?vue&type=template&id=7e553c5c"
import script from "./Pediatrics.vue?vue&type=script&lang=ts"
export * from "./Pediatrics.vue?vue&type=script&lang=ts"
script.render = render

export default script